<template>
  <div class="relative h-full">
    <div class="flex items-end justify-between h-full gap-1 px-2">
      <div
        v-for="(item, index) in normalizedData"
        :key="index"
        class="flex-1 flex flex-col items-center group relative"
      >
        <!-- Bar -->
        <div class="w-full flex flex-col justify-end" :style="{ height: chartHeight + 'px' }">
          <div
            :class="barColor"
            class="w-full rounded-t transition-all duration-300 hover:opacity-80 cursor-pointer relative"
            :style="{ height: item.percentage + '%' }"
          >
            <!-- Tooltip -->
            <div class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
              <div class="bg-gray-900 dark:bg-gray-700 text-white text-xs rounded py-1 px-2 whitespace-nowrap shadow-lg">
                <div class="font-semibold">{{ item.value }}</div>
                <div v-if="showCurrency" class="text-[10px] text-gray-300">${{ formatNumber(item.rawValue) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Label -->
        <div class="text-[9px] text-gray-500 dark:text-gray-400 mt-1 text-center truncate w-full">
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  data: {
    type: Array,
    required: true,
    // Formato: [{ label: 'Label', value: 123 }, ...]
  },
  barColor: {
    type: String,
    default: 'bg-violet-500 dark:bg-violet-600'
  },
  chartHeight: {
    type: Number,
    default: 120
  },
  showCurrency: {
    type: Boolean,
    default: false
  }
})

const normalizedData = computed(() => {
  if (!props.data || props.data.length === 0) return []

  const maxValue = Math.max(...props.data.map(d => d.value))

  return props.data.map(item => ({
    label: item.label,
    value: item.value,
    rawValue: item.value,
    percentage: maxValue > 0 ? (item.value / maxValue) * 100 : 0
  }))
})

const formatNumber = (num) => {
  return new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(num)
}
</script>
